export enum SearchAnalyticsEnum {
  LEAD_SEARCH_NOTIFY_ME = '[PAC WEB] Resultado de busca - Formulário de avise-me',
  VIEW_SEARCH_RESULTS = '[PAC WEB] Visualizou resultados da busca',
  CLICK_SEARCH_RESULT_AVATAR = '[PAC WEB] Resultados da busca - Clicou no avatar',
  CLICK_SEARCH_RESULT_PARTNER_NAME = '[PAC WEB] Resultados da busca - Clicou no nome do parceiro',
  CLICK_EXPAND_SEARCH_RESULT_ADDRESS = '[PAC WEB] Resultados da busca - Expandiu endereço',
  CLICK_OPEN_MAP_SEARCH_RESULT = '[PAC WEB] Resultado da busca - Clicou em "Abrir no mapa"',
  CLICK_SEE_MORE_SEARCH_RESULTS = '[PAC WEB] Resultado da busca - Clicou em "Ver mais resultados"',
  CLICK_SEARCH_RESULT_COVERAGE_VIEW = '[PAC WEB] Resultados da busca - Clicou em "Ver" cobertura de exames',

  VIEW_ARRIVAL_ORDER_MODAL = '[PAC WEB] Resultado - Abriu modal de horários',
  CLICK_ARRIVAL_ORDER_DATE_NAV = '[PAC WEB] Resultado - Navegou datas nos horários',
  CLICK_ARRIVAL_ORDER_SLOT = '[PAC WEB] Resultado - Selecionou horário',
  CLOSE_ARRIVAL_ORDER_MODAL = '[PAC WEB] Resultado - Fechou modal de horários',

  CLICK_ADD_STANDALONE_GUIDE = '[PAC WEB] Resultado - Clicou em Adicionar guia avulsa',
  STANDALONE_SELECT_PATIENT = '[PAC WEB] Guia avulsa - Selecionou paciente',
  STANDALONE_ADD_TO_CART = '[PAC WEB] Guia avulsa - Adicionou ao carrinho',

  SEARCH_SUGGESTION_TELEHEALTH_SHOWN = '[PAC WEB] Sugestões - Teleconsulta exibida',
  SEARCH_SUGGESTION_TELEHEALTH_OPTION_CLICKED = '[PAC WEB] Sugestões - Clicou em opção de teleconsulta',

  SEARCH_SUGGESTION_NEAR_CITY_SHOWN = '[PAC WEB] Sugestões - Cidades próximas exibidas',
  SEARCH_SUGGESTION_NEAR_CITY_SELECTED = '[PAC WEB] Sugestões - Selecionou cidade próxima',

  SORT_OPEN_SELECTOR = '[PAC WEB] Ordenação - Abriu seletor de ordenação',
  SORT_SELECTED = '[PAC WEB] Ordenação - Selecionou ordenação',
}
